module.exports = __webpack_public_path__ + "static/media/prisma.1e06f3a6.svg";